"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMapContainerCorners = exports.getMarkerIconForState = exports.MarkerState = exports.maplibre = void 0;
const maplibre_gl_csp_js_1 = __importDefault(require("maplibre-gl/dist/maplibre-gl-csp.js"));
exports.maplibre = maplibre_gl_csp_js_1.default;
__exportStar(require("./AwsMap"), exports);
__exportStar(require("./types"), exports);
var constants_1 = require("./lib/constants");
Object.defineProperty(exports, "MarkerState", { enumerable: true, get: function () { return constants_1.MarkerState; } });
var utils_1 = require("./lib/utils");
Object.defineProperty(exports, "getMarkerIconForState", { enumerable: true, get: function () { return utils_1.getMarkerIconForState; } });
Object.defineProperty(exports, "getMapContainerCorners", { enumerable: true, get: function () { return utils_1.getMapContainerCorners; } });
//# sourceMappingURL=index.js.map